/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */

import { ReactElement } from 'react';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';

type TruncatedTextProps = {
    text?: string;
    maxLength?: number;
};

const TruncatedTextWithPopover = ({ text, maxLength }: TruncatedTextProps): ReactElement => {
    const maxLengthOrDefault = maxLength ?? 100;

    if (text !== undefined && text.length > maxLengthOrDefault) {
        return (
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <span>{text?.slice(0, maxLengthOrDefault)}...</span>
                    </TooltipTrigger>
                    <TooltipContent>
                        <div className="text-pretty max-w-sm md:max-w-md lg:max-w-lg">{text}</div>
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        );
    }
    return <span>{text}</span>;
};

export default TruncatedTextWithPopover;
